import { UpsellModalType } from 'modules/upsells/stores/types';

export function formatUpsellModalTypeAsString(type?: UpsellModalType): string | undefined {
  return type ? type.replace(/^Contextt?ual/, '') : undefined;
}
